import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
} from "@chakra-ui/react";
import {
  CONDICOES_SEGURO_CONCILIACAO,
  CONDICOES_SEGURO_LABEL,
  CondicaoSeguroConciliacao,
} from "@/models/conciliation-config.model";
import { ConfiguracaoFormFieldsProps } from "./types";

export function ConfiguracaoFormFields({
  configuracaoForm,
  editingConfiguracaoId,
  onChangeNome,
  onChangeOrdem,
  onChangeVersao,
  onChangeCondicaoSeguroEtapa,
}: ConfiguracaoFormFieldsProps) {
  return (
    <>
      <Text fontWeight="bold" mb={4}>
        {editingConfiguracaoId ? "Editar configuração" : "Criar configuração"}
      </Text>

      <Flex direction={{ base: "column", md: "row" }} gap={4} mb={4}>
        <FormControl isRequired>
          <FormLabel>Nome</FormLabel>
          <Input
            value={configuracaoForm.nome}
            onChange={(event) => onChangeNome(event.target.value)}
            placeholder="Nome da etapa de conciliação"
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Ordem</FormLabel>
          <Input
            type="number"
            placeholder="0"
            value={configuracaoForm.ordem || ""}
            onChange={(event) => onChangeOrdem(Number(event.target.value))}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Versão</FormLabel>
          <Input
            type="number"
            placeholder="0"
            value={configuracaoForm.configuracao.versao || ""}
            onChange={(event) => onChangeVersao(Number(event.target.value))}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Condição de seguro da etapa</FormLabel>
          <Select
            value={configuracaoForm.condicaoSeguro ?? "QUALQUER"}
            onChange={(event) =>
              onChangeCondicaoSeguroEtapa(
                event.target.value as CondicaoSeguroConciliacao
              )
            }
          >
            {CONDICOES_SEGURO_CONCILIACAO.map((condicao) => (
              <option key={condicao} value={condicao}>
                {CONDICOES_SEGURO_LABEL[condicao]}
              </option>
            ))}
          </Select>
          <Text fontSize="sm" fontWeight={500} color="gray.500" mt={1}>
            Define se a etapa roda com ou sem seguro, apenas com seguro ou apenas
            sem seguro.
          </Text>
        </FormControl>
      </Flex>
    </>
  );
}